import { lazy } from 'react';
import { withSuspense } from '../../hoc/with-suspense/WithSuspense';
var DateTimePickerLazy = lazy(() => import('./DateTimePickerComponent'));
export var DateTimePicker = withSuspense(DateTimePickerLazy);